import React from 'react';
import Icon from '../../../components/AppIcon';

const TicketStatisticsCard = ({ title, value, subtitle, icon, color }) => {
  const getColorStyles = () => {
    const colors = {
      blue: {
        bg: 'bg-blue-500/10',
        text: 'text-blue-600',
        border: 'border-blue-500/20'
      },
      red: {
        bg: 'bg-red-500/10',
        text: 'text-red-600',
        border: 'border-red-500/20'
      },
      amber: {
        bg: 'bg-amber-500/10',
        text: 'text-amber-600',
        border: 'border-amber-500/20'
      },
      green: {
        bg: 'bg-green-500/10',
        text: 'text-green-600',
        border: 'border-green-500/20'
      }
    };
    return colors?.[color] || colors?.blue;
  };

  const styles = getColorStyles();

  return (
    <div className={`bg-card border ${styles?.border} rounded-lg p-6 transition-smooth hover:shadow-md`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`${styles?.bg} ${styles?.text} p-3 rounded-md`}>
          <Icon name={icon} size={20} color="currentColor" />
        </div>
      </div>
      <h3 className="text-sm text-muted-foreground mb-2">{title}</h3>
      <div className="flex items-baseline gap-2 mb-1">
        <span className={`text-3xl font-bold ${styles?.text}`}>
          {value}
        </span>
      </div>
      {subtitle && (
        <p className="text-xs text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default TicketStatisticsCard;